import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timesince',
  standalone: true
})
export class TimesincePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    if (value < 60) {
      return `${value} mins ago`
    }
    const numOfHours = Math.round(value / 60);
    if (numOfHours < 24) {
      return `${numOfHours} hours ago`
    }
    const numOfDays = Math.round(numOfHours / 24);
    return `${numOfDays} days ago`;
  }

}
